import { useTranslation } from "react-i18next";

import { useUpdatePolicyMutation } from "@dashboard/policies/api";
import type { UpdatePolicyPayload } from "@dashboard/policies/api/rtkClient";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";
import { getErrorMessage } from "@shared/toasts/useQueryErrorToast";

export const usePolicyContentUpdate = () => {
    const { t } = useTranslation(["pages"]);
    const [updatePolicy, { isLoading }] = useUpdatePolicyMutation();

    const updateContent = async (payload: UpdatePolicyPayload, options?: { silent?: boolean }): Promise<boolean> => {
        try {
            await updatePolicy(payload).unwrap();
            if (!options?.silent) {
                showSuccessToast(t("pages:policiesPage.toast.rulesUpdated"));
            }
            return true;
        } catch (error) {
            showErrorToast(getErrorMessage(error));
            return false;
        }
    };

    return { updateContent, isLoading };
};
